
import React, { FC, memo, useCallback, useEffect, useLayoutEffect, useMemo, useState } from "../../../lib/teact/teact";
import { tienFormat } from "../utils/NumberUtils";
import { isCuPhapMn } from "../utils/common";
import { NhanVeItemData } from "./workingTypes";
import "./NhanVeItem.scss";

type OwnProps = {
    dataItem: NhanVeItemData;
    index: number;
}

const RptDetailsItem: FC<OwnProps> = ({
    dataItem,
    index
}) => {
    return (
        <div className={isCuPhapMn() ? "th-grid-nhan-ve" : "th-grid-nhan-ve-mb"}>
            {isCuPhapMn() ?
                <div className="stt-dai">
                    <div>{index}</div>
                    <div className={"th-left-align" + ((dataItem.trung != 0) ? " trung" : "")}>
                        {dataItem.daiId1}{dataItem.daiId2 != "" ? "," + dataItem.daiId2 : ""}

                    </div >
                </div>
                : <div className="stt">
                    {index}
                </div >
            }
            <div className={"th-left-align" + ((dataItem.trung != 0) ? " trung" : "")}>
                {dataItem.loaiCuocId}
            </div>
            <div className={"th-left-align" + ((dataItem.trung != 0) ? " trung" : "")}>
                {dataItem.soCuoc}
            </div>
            <div className={"th-left-align" + ((dataItem.trung != 0) ? " trung" : "")}>
                {dataItem.trung != 0
                    ? (tienFormat(dataItem.trung, 1) + ("DaT,DaX".includes(dataItem.loaiCuocId) ? " +" : ""))
                    : ""}
            </div>
            <div className={" th-right-align " + ((dataItem.trung != 0) ? " trung" : "")}>
                {tienFormat(dataItem.sumDiem, 1)}
            </div>
        </div>

    )
}

export default memo(RptDetailsItem)